export default {
  stringEmpty: str => {
    return str === '' || str === null || str === undefined
  },
  notEmpty(str) {
    return !this.stringEmpty(str)
  },
  arrayEmpty: arr => {
    return arr.length === 0 || arr.indexOf('') !== -1
  },
  isEmail: str => {
    return /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,}/.test(str)
  },
  isInteger: str => {
    return /^\d+$/.test(str)
  },
  isDecimal: str => {
    return /^\d+(\.\d+)?$/.test(str)
  },
  isAmount: str => {
    return /^\d+(\.\d\d)?$/.test(str)
  },
  isNumberBetween: (num, minNum = 0, maxNum = Number.MAX_VALUE) => {
    return !isNaN(num) && num % 1 === 0 && num >= minNum && num <= maxNum
  },
  isWebsiteUrl: str => {
    return /^(https?:\/\/)([\w-])+\.{1}([a-zA-Z]{2,63})([/\w-]*)*\/?\??([^#\n\r]*)?#?([^\n\r]*)$/.test(str)
  },
  isValidPassword: str => {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(str)
  },
  isSame: (value, compareValue) => {
    return value === compareValue
  },
  isBoolean: val => {
    return val === true || val === false
  }
}
